// Profiles created by other products in the shared Supabase project have no
// condominium relationship. Platform administrators are the only itaCondo
// profiles that are intentionally allowed to exist without one.
export const ITACONDO_PROFILE_FILTER = "condominium_id.not.is.null,role.eq.superadmin"
